import { useQuery } from "@tanstack/react-query"
import {
  getMissingPathologyLogStats,
  getMissingPathologyLogsByMissingPathology,
  getMissingPathologyLogByLogId,
  getDistinctBodyParts,
} from "../api/missingPathologyLogs"

export const useMissingPathologyLogsStats = ({ sortBy, filters }) =>
  useQuery({
    queryKey: ["missing-pathology-log-stats", sortBy, filters],
    queryFn: () => getMissingPathologyLogStats({ sortBy, filters }),
    retry: false,
    select: (data) => data?.data,
  })

export const useMissingPathologyLogsByMissingPathology = ({
  page,
  limit,
  sortBy,
  filters,
}) =>
  useQuery({
    queryKey: ["missing-pathology-logs", page, limit, sortBy, filters],
    queryFn: () =>
      getMissingPathologyLogsByMissingPathology({
        page,
        limit,
        sortBy,
        filters,
      }),
    retry: false,
    enabled: !!filters.Pathology && !!filters.BodyPart,
    select: (data) => data?.data,
  })

export const useMissingPathologyLogByLogId = (missingPathologyLogId) =>
  useQuery({
    queryKey: ["missing-pathology-log", missingPathologyLogId],
    queryFn: () => getMissingPathologyLogByLogId(missingPathologyLogId),
    retry: false,
    enabled: !!missingPathologyLogId,
    select: (data) => data?.data,
  })

export const useDistinctBodyParts = () =>
  useQuery({
    queryKey: ["distinct-body-parts"],
    queryFn: () => getDistinctBodyParts(),
    retry: false,
  })
